import { Button } from '@workramp/ui';
import styled from 'styled-components';
import { I18n } from '~/common/explicit-exports';

type AdvancedSearchLoadMoreProps = {
  onClick: () => void;
};

export const ShowButton = styled(Button)`
  padding-left: ${({ theme }) => `${theme.spacing(6)}px`};
`;

export const AdvancedSearchLoadMore = ({ onClick }: AdvancedSearchLoadMoreProps) => {
  const LOAD_MORE = I18n.t('js.learner.search.load_more');
  return (
    <ShowButton variant="text" color="secondary" onPressStart={onClick}>
      {LOAD_MORE}
    </ShowButton>
  );
};
